import React from "react";
import { connect } from "react-redux";
import update from "immutability-helper";
import Notifications from "react-notification-system-redux";
import T from "i18n-react";
import { Renderer } from "../../form-renderer/src/renderer";
import request from "superagent";
import config from "../../config";
const mapDispatchToProps = dispatch => ({
	dispatch
});

const answered = question => {
	return (
		(typeof question.text === "string" ? !!question.text.length : false) ||
		(typeof question.date === "string" ? !!question.date.length : false) ||
		(typeof question.time === "string" ? !!question.time.length : false) ||
		(question.calculation !== null && question.calculation.result) ||
		(question.datasheet &&
			question.datasheet.hasOwnProperty("columns") &&
			question.datasheet.hasOwnProperty("rows") &&
			question.datasheet.hasOwnProperty("data") &&
			Array.isArray(question.datasheet.rows) &&
			Array.isArray(question.datasheet.columns) &&
			Array.isArray(question.datasheet.data) &&
			question.datasheet.data.some(row => {
				return row.some(v => {
					return !!v;
				});
			})) ||
		(Array.isArray(question.selected)
			? !!question.selected.length
			: false) ||
		(typeof question.number === "string"
			? !!question.number.length
			: false) ||
		(Array.isArray(question.rows) ? !!question.rows.length : false) ||
		(typeof question.fileId === "string"
			? !!question.fileId.length
			: false) ||
		typeof question.number === "number"
	);
};

export class FormRender extends React.Component {
	constructor(props) {
		super(props);
		this.storageKey = this.storageKey.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.clear = this.clear.bind(this);
		this.onData = this.onData.bind(this);
		this.state = {
			form: props.form
		};
	}

	getContacts = () => {
		let contacts = [];
		if (this.props.contacts) {
			contacts = this.props.contacts;
		}

		return new Promise((resolve, reject) => {
			resolve({
				body: contacts
			});
		});
	};

	componentWillReceiveProps(nextProps) {
		if (this.props.form !== nextProps.form) {
			this.setState({
				form: nextProps.form
			});
		}
	}

	storageKey() {
		return (
			"formRenderer-" +
			window.localStorage.userId +
			"-" +
			this.props.form.id
		);
	}

	onSubmit(data) {
		data.values = data.values.filter(answered);
		return request
			.post(
				config.API_BASE + "/forms/" + this.props.form.id + "/data"
			)
			.send(data)
			.then(
				resp => {
					// Reset
					if (window.localStorage) {
						window.localStorage.removeItem(this.storageKey());
						this.setState({
							form: update(this.state.form, {
								$unset: ["savedState"]
							})
						});
					}

					this.props.dispatch(
						Notifications.success({
							title: "",
							message:
								T.translate("form.submit-success") +
								" " +
								this.props.publication.objectNumber +
								"-" +
								resp.body.humanReadableId.trim(),
							position: "tc",
							autoDismiss: 5
						})
					);
					return resp.body;
				},
				() => {
					this.props.dispatch(
						Notifications.error({
							title: "",
							message: T.translate("form.submit-failure"),
							position: "tc",
							autoDismiss: 5
						})
					);
				}
			)
			.then(resp => {
				this.props.onAfterSubmit(resp);
				return resp;
			});
	}

	clear() {
		// Reset
		setTimeout(() => {
			if (window.localStorage) {
				window.localStorage.removeItem(this.storageKey());
				this.setState({
					form: update(this.state.form, {
						$unset: ["savedState"]
					})
				});
			}
		});
	}

	onData(data) {
		// Save values to be able to restore them later
		// Only save the values, the identification and signature are not interesting
		window.localStorage[this.storageKey()] = JSON.stringify(data.values);
	}

	getLittera = customerId => {
		return new Promise((resolve, reject) => {
			let resp = { body: { projects: [] } };
			if (
				this.props.listCustomers &&
				this.props.listCustomers.length > 0
			) {
				let customer = this.props.listCustomers.filter(c => {
					return c.id === customerId;
				});
				if (customer.length > 0) {
					resp.body.projects = customer[0].projects;
				}
			}
			resolve(resp);
		});
	};

	componentDidMount() {
		if (window.localStorage) {
			// Attempt to read a saved form state for the current form and user
			try {
				if (
					typeof window.localStorage[this.storageKey()] === "string"
				) {
					let data = JSON.parse(
						window.localStorage[this.storageKey()]
					);
					if (typeof data === "object") {
						let form = Object.assign({}, this.prop.form);
						form.savedState = {
							values: data
						};
						this.setState({
							form
						});
					}
				}
			} catch (_) { }
		}
	}
	render() {
		let form = Object.assign({}, this.state.form);
		form.layoutFormType = this.props.layoutFormType || "default";
		form.listSources = {
			ALL: [],
			"customers-ALL": []
		};

		// if (this.props.formData.Products) {
		// 	this.props.formData.Products.forEach(p => {
		// 		if (p.categoryId) {
		// 			if (!form.listSources[p.categoryId]) {
		// 				form.listSources[p.categoryId] = [p];
		// 			} else {
		// 				form.listSources[p.categoryId].push(p);
		// 			}
		// 		}
		// 	});

		// 	form.listSources["ALL"] = this.props.formData.Products;
		// }

		// if (this.props.formData.Customers) {
		// 	if (this.props.formData.CustomerCategories) {
		// 		this.props.formData.CustomerCategories.forEach(s => {
		// 			s.items = this.props.formData.Customers.filter(c => {
		// 				let x = c.categoryIds.filter(id => {
		// 					return id === s.id;
		// 				});
		// 				return x.length > 0;
		// 			});

		// 			form.listSources["customers-" + s.id] = s.items;
		// 		});
		// 	}

		// 	form.listSources["customers-ALL"] = this.props.formData.Customers;
		// }

		if (window.localStorage) {
			// Attempt to read a saved form state for the current form and user
			try {
				if (
					typeof window.localStorage[this.storageKey()] === "string"
				) {
					let data = JSON.parse(
						window.localStorage[this.storageKey()]
					);
					if (typeof data === "object") {
						form.savedState = {
							values: data
						};
					}
				}
			} catch (_) { }
		}

		form.listSourceToText = (listSource, i, priceList) => {
			if (
				typeof listSource === "string" &&
				listSource.indexOf("customers-") === 0
			) {
				return i.reference ? i.name + ": " + i.reference : i.name;
			}

			let price = "";

			for (let k in i.pricelist) {
				if (i.pricelist[k].priceListId !== priceList) {
					continue;
				}

				price = i.pricelist[k].price + " " + i.pricelist[k].currency;
			}

			return {
				label: i.sku + " – " + i.name + (price ? " – " + price : ""),
				value:
					i.id +
					"_" +
					i.sku +
					" – " +
					i.name +
					" – " +
					i.unit +
					(price ? " – " + price : "")
			};
		};

		return (
			<Renderer
				{...form}
				onData={this.onData}
				onClearForm={this.clear}
				onSubmit={this.onSubmit}
				clearBtnOnTop={true}
				getLittera={this.getLittera}
				getContacts={this.getContacts}
				companyId={this.props.companyId}
				publicationDescription={
					this.props.publication.description || ""
				}
				publicationId={this.props.publication.id}
			/>
		);
	}
}

export default connect(
	null,
	mapDispatchToProps
	// Implement map dispatch to props
)(FormRender);
